// src/pages/PrivacyPolicy.js
import React from "react";
import "./PolicyPages.css";

export default function PrivacyPolicy() {
  return (
    <div className="policy-container">
      <div className="policy-card">
        <h1>Privacy Policy</h1>
        <p className="policy-date">Last updated: September 2026</p>

        <section>
          <h2>1. Who we are</h2>
          <p>
            Marakwet Community in Australia Inc. (ABN: 71 311 378 405) is a registered
            incorporated association in Victoria, Australia. We operate the website
            at <strong>marakwetcommunityinaustralia.org</strong>  to
            provide community membership, event ticketing, and welfare services to
            members of the Marakwet community living in Australia.
          </p>
          <p>
            Contact email: <a href="mailto:info@marakwetcommunityinaustralia.org">info@marakwetcommunityinaustralia.org</a>
            <br />
            Phone: +61 411 494 404
          </p>
        </section>

        <section>
          <h2>2. What information we collect</h2>
          <p>When you register as a member, purchase event tickets, or contact us, we collect:</p>
          <ul>
            <li>Full name, date of birth</li>
            <li>Email address and phone number</li>
            <li>Membership plan and payment history (amounts and dates — not card numbers)</li>
            <li>Event ticket purchases — event name, date, ticket quantity, and attendee details you provide</li>
            <li>Welfare program enrolment details (if applicable)</li>
            <li>Messages you send via our contact forms</li>
          </ul>
          <p>
            We also use cookies to keep you logged in during your session. We do not
            use tracking or advertising cookies.
          </p>
        </section>

        <section>
          <h2>3. Payment card data</h2>
          <p>
            <strong>We do not collect, store or transmit your payment card details.</strong>
          </p>
          <p>
            All card information (card number, expiry date, CVV) is entered directly
            into secure, encrypted fields provided by <strong>Stripe</strong> (Stripe
            Payments Australia Pty Ltd). Stripe is a PCI DSS Level 1 certified payment
            processor. Your card data goes from your browser directly to Stripe's
            servers — it never passes through or is stored on our systems.
          </p>
          <p>
            For more information about Stripe's security, visit{" "}
            <a
              href="https://stripe.com/au/privacy"
              target="_blank"
              rel="noreferrer"
            >
              stripe.com/au/privacy
            </a>.
          </p>
        </section>

        <section>
          <h2>4. How we use your information</h2>
          <ul>
            <li>To process your membership registration and payments</li>
            <li>To process event ticket purchases and send booking confirmations</li>
            <li>To send you event reminders and updates for events you have registered for</li>
            <li>To send you membership confirmation and account setup emails</li>
            <li>To administer the welfare support program</li>
            <li>To respond to enquiries and messages you send us</li>
            <li>To comply with our legal obligations under Australian law</li>
          </ul>
          <p>
            We will not use your personal information for direct marketing without
            your consent, and we will not sell or rent your information to third parties.
          </p>
        </section>

        <section>
          <h2>5. Who we share your information with</h2>
          <p>We share your information only where necessary:</p>
          <ul>
            <li>
              <strong>Stripe</strong> — to process card payments for memberships and
              event tickets securely
            </li>
            <li>
              <strong>Mailgun</strong> — to send transactional emails (ticket
              confirmations, membership confirmations, password setup links)
            </li>
            <li>
              <strong>MCIA event organisers</strong> — attendee names and contact
              details may be shared with authorised MCIA organisers solely for the
              purpose of managing the event you registered for
            </li>
            <li>
              Government or regulatory bodies if required by law
            </li>
          </ul>
          <p>We do not share your information with any other third parties.</p>
        </section>

        <section>
          <h2>6. Data security</h2>
          <p>
            We take reasonable steps to protect the personal information we hold,
            including:
          </p>
          <ul>
            <li>Encrypted HTTPS connections on our website</li>
            <li>
              JWT (JSON Web Token) authentication for member accounts — passwords
              are hashed and never stored in plain text
            </li>
            <li>
              Payment data handled entirely by Stripe — not stored on our servers
            </li>
            <li>Access to member and ticketing data restricted to authorised community administrators</li>
          </ul>
        </section>

        <section>
          <h2>7. Your rights</h2>
          <p>Under the Australian Privacy Act 1988, you have the right to:</p>
          <ul>
            <li>Access the personal information we hold about you</li>
            <li>Ask us to correct inaccurate information</li>
            <li>Request deletion of your personal information (subject to legal requirements)</li>
          </ul>
          <p>
            To exercise these rights, contact us at{" "}
            <a href="mailto:info@marakwetcommunityinaustralia.org">
              info@marakwetcommunityinaustralia.org
            </a>
            . We will respond within 30 days.
          </p>
        </section>

        <section>
          <h2>8. Ticket refunds and cancellations</h2>
          <p>
            Event ticket purchases are subject to MCIA's event refund policy. For
            refund requests, contact{" "}
            <a href="mailto:info@marakwetcommunityinaustralia.org">
              info@marakwetcommunityinaustralia.org
            </a>{" "}
            with your booking details. Refunds, where approved, are returned to the
            original payment method via Stripe.
          </p>
        </section>

        <section>
          <h2>9. Changes to this policy</h2>
          <p>
            We may update this Privacy Policy from time to time. The date at the
            top of this page shows when it was last revised. Continued use of the
            Site after changes constitutes acceptance of the updated policy.
          </p>
        </section>

        <section>
          <h2>10. Contact us</h2>
          <p>
            For any privacy-related questions or complaints, please contact:
            <br />
            <strong>Marakwet Community in Australia Inc.</strong>
            <br />
            Email:{" "}
            <a href="mailto:info@marakwetcommunityinaustralia.org">
              info@marakwetcommunityinaustralia.org
            </a>
            <br />
            Phone: +61 411 494 404
          </p>
        </section>
      </div>
    </div>
  );
}